import { render, staticRenderFns } from "./LalamoveErrorPage.vue?vue&type=template&id=37b2453f&scoped=true"
import script from "./LalamoveErrorPage.vue?vue&type=script&lang=js"
export * from "./LalamoveErrorPage.vue?vue&type=script&lang=js"
import style0 from "./LalamoveErrorPage.vue?vue&type=style&index=0&id=37b2453f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2453f",
  null
  
)

export default component.exports